const scriptAnalysisLanguages = ["sv", "no", "nb", "fi", "en", "de", "es", "fr", "bg", "it", "nl", "da"];

export default scriptAnalysisLanguages;
